import React from 'react';
import logo from './logo.svg';
import './App.css';
import Routesfun from './AllRoutes/Routes';

function App() {
  return (
    <div className="App">
      <Routesfun />
    </div>
  );
}

export default App;
